import { AppBridge } from 'infrastructure/appBridge/appBridge';
import { APP_BRIDGE_CALLBACKS } from 'infrastructure/appBridge/appCallBacks';
import { APP_PRO_MONITORING_SCREEN, QUERY_PARAMS } from 'utils/constants';

export const isRunningInWebView = () => {
  // Native bridge checks
  const hasAndroidBridge = !!window.Android;
  const hasIOSBridge = !!window.webkit && !!window.webkit.messageHandlers;

  // // Get user agent
  const ua = navigator.userAgent;

  // // Specific browser identifications
  const isIOSChrome = /CriOS\/[0-9]/.test(ua);
  // const isStandardChrome =
  //   /Chrome\/[0-9]/.test(ua) && !(/Android/.test(ua) && /wv/.test(ua));
  // const isSafari =
  //   /Safari\/[0-9]/.test(ua) &&
  //   !/CriOS/.test(ua) &&
  //   !/FxiOS/.test(ua) &&
  //   !/EdgiOS/.test(ua);
  // const isFirefox = /Firefox\/[0-9]/.test(ua) || /FxiOS\/[0-9]/.test(ua);
  // const isEdge = /Edge\/[0-9]/.test(ua) || /EdgiOS\/[0-9]/.test(ua);
  // const isSamsungBrowser = /SamsungBrowser\/[0-9]/.test(ua);

  // // Combined browser check
  // const isStandardBrowser =
  //   isIOSChrome ||
  //   isStandardChrome ||
  //   isSafari ||
  //   isFirefox ||
  //   isEdge ||
  //   isSamsungBrowser;

  // // WebView specific patterns
  // const hasWebViewMarker =
  //   /wv/.test(ua) ||
  //   /FBAN/.test(ua) ||
  //   /FBAV/.test(ua) ||
  //   /Instagram/.test(ua) ||
  //   /Line\//.test(ua);

  // // Android specific WebView checks
  // const isAndroidWebView =
  //   /Android/.test(ua) &&
  //   (hasWebViewMarker ||
  //     hasAndroidBridge ||
  //     (/Android/.test(ua) && /Version\/[0-9]/.test(ua) && !isSamsungBrowser));

  // // iOS specific WebView checks
  // const isIOSWebView =
  //   /iPhone|iPad|iPod/.test(ua) &&
  //   (hasIOSBridge ||
  //     (/AppleWebKit/.test(ua) &&
  //       !isSafari &&
  //       !isIOSChrome &&
  //       !/FxiOS/.test(ua) &&
  //       !/EdgiOS/.test(ua)));

  // return (
  //   (isAndroidWebView || isIOSWebView || hasWebViewMarker) && !isStandardBrowser
  // );
  return (hasAndroidBridge || hasIOSBridge) && !isIOSChrome;
};

export const APP_BUTTON_TYPES = {
  CLOSE: 'close',
  RELOAD: 'reload',
  BACK: 'back'
} as const;

export type AppButtonType =
  (typeof APP_BUTTON_TYPES)[keyof typeof APP_BUTTON_TYPES];

export const showAppButton = (...buttonsToShow: AppButtonType[]) => {
  try {
    console.log('showing buttons');
    if (!buttonsToShow.includes('close')) {
      console.log('not close buttons');
      AppBridge.sendMessageToApp(APP_BRIDGE_CALLBACKS.HIDE_CLOSE_BUTTON);
    } else {
      console.log('close buttons');
      AppBridge.sendMessageToApp(APP_BRIDGE_CALLBACKS.SHOW_CLOSE_BUTTON);
    }

    if (!buttonsToShow.includes('reload')) {
      console.log('not reload buttons');
      AppBridge.sendMessageToApp(APP_BRIDGE_CALLBACKS.HIDE_RELOAD_BUTTON);
    } else {
      console.log('reload buttons');
      AppBridge.sendMessageToApp(APP_BRIDGE_CALLBACKS.SHOW_RELOAD_BUTTON);
    }

    if (!buttonsToShow.includes('back')) {
      console.log('not back buttons');
      AppBridge.sendMessageToApp(APP_BRIDGE_CALLBACKS.HIDE_BACK_BUTTON);
    } else {
      console.log('back buttons');
      AppBridge.sendMessageToApp(APP_BRIDGE_CALLBACKS.SHOW_BACK_BUTTON);
    }
  } catch (err) {
    console.error('Error while showing app buttons', err);
  }
};

export const hideAppButton = () => {
  try {
    console.log('hiding buttons');
    AppBridge.sendMessageToApp(APP_BRIDGE_CALLBACKS.HIDE_CLOSE_BUTTON);
    AppBridge.sendMessageToApp(APP_BRIDGE_CALLBACKS.HIDE_RELOAD_BUTTON);
    AppBridge.sendMessageToApp(APP_BRIDGE_CALLBACKS.HIDE_BACK_BUTTON);
  } catch (err) {
    console.error('Error while hiding app buttons', err);
  }
};

export const isAndroidWebView = !!window.Android;

export const isIOSWebView = !!window.webkit && !!window.webkit.messageHandlers;

// Fetch Access Token

export const fetchWebViewAccessToken = async (
  needRefresh: boolean = false
): Promise<string> => {
  try {
    const res = await AppBridge.sendMessageToAppWithReturn(
      APP_BRIDGE_CALLBACKS.GET_ACCESS_TOKEN,
      {
        needRefresh
      }
    );
    if (isAndroidWebView) {
      console.log('Android webview detected');
      return JSON.parse(res as string)?.accessToken;
    }
    if (isIOSWebView) {
      console.log('iOS webview detected');
      return JSON.parse(JSON.stringify(res))?.accessToken;
    }
    return JSON.parse(res as string)?.accessToken;
  } catch (err) {
    console.error('Error fetching access token', err);
    throw new Error('Error fetching access token');
  }
};

export const closeInAppWebviewWithAppRoute = async (navigation: string) => {
  try {
    await AppBridge.sendMessageToAppWithParam(
      APP_BRIDGE_CALLBACKS.CLOSE_IN_APP_WEBVIEW,
      {
        navigation
      }
    );
    if (isAndroidWebView) {
      console.log('closing android webview, navigate to:', navigation);
      // Adding closeWebview Callback in case of android for backward compatibility with previous version android apps
      // as they dont expect the arguments, with arguments they ignore the call only which is not the case with IOS
      AppBridge.sendMessageToApp(APP_BRIDGE_CALLBACKS.CLOSE_IN_APP_WEBVIEW);
    }
    if (isIOSWebView) {
      console.log('closing iso webview, navigate to:', navigation);
    }
  } catch (err) {
    console.error('Error closing webview', err);
    throw new Error('Error closing webview');
  }
};

/**
 * The single producer of the `navigation` value sent to the app on close.
 *
 * Priority is deliberate and must not be reordered without a decision:
 *   1. the post-pairing flow for this session — either injected by the app
 *      (older builds) or resolved from the device at boot, both stored under
 *      the same key so this does not need to know which
 *   2. pro-monitoring, when the plan just purchased includes it. Only knowable
 *      after the purchase settles, which is why the webview arbitrates rather
 *      than the app
 *   3. no target — the app falls back to its own default
 *
 * Reads localStorage directly rather than via `utils/commonFunctions`, which
 * pulls in the partners/assets import cycle and boots on incidental ordering.
 */
export const closeWebviewToPostPairingTarget = (opts?: {
  isProMonitoring?: boolean;
}) => {
  // Empty when the app injected nothing and the model has no flow configured.
  // Anything non-empty is a destination the app knows how to route to.
  const flow = localStorage.getItem(QUERY_PARAMS.POST_PAIRING_FLOW) || '';
  if (flow) {
    return closeInAppWebviewWithAppRoute(flow);
  }
  if (opts?.isProMonitoring) {
    return closeInAppWebviewWithAppRoute(APP_PRO_MONITORING_SCREEN);
  }
  return AppBridge.sendMessageToApp(APP_BRIDGE_CALLBACKS.CLOSE_IN_APP_WEBVIEW);
};

/**
 * The post-purchase "go home" side effect several result popups repeated
 * identically: tell the app the subscription changed, then resolve wherever
 * `closeWebviewToPostPairingTarget` sends it. `isProMonitoring` only matters
 * to the free-trial-activated popup today; every other caller omits it.
 */
export const closeWebviewAfterPurchase = (opts?: {
  isProMonitoring?: boolean;
}) => {
  AppBridge.sendMessageToApp(APP_BRIDGE_CALLBACKS.UPDATED_SUBSCRIPTION);
  return closeWebviewToPostPairingTarget(opts);
};
